'use client'

import styled from "styled-components";
import {getColor, getMedias} from "@/pipes/theme.pipe";
import {getSectionPaddingsInline} from "@/components/UI/Section/Section.utils";

export const AuthLayoutStyled = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`

export const AuthContentWrapper = styled.div`
    display: flex;
    flex: 1; 
    border-top: 1px solid ${getColor('secondary', '900')};
`

export const IllustrationWrapper = styled.div`
    background-image: url("/images/auth-background.svg"), linear-gradient(#0575E6, #021B79);
    background-repeat: no-repeat;
    background-position: left bottom;
    background-size: 70%, 100%;
    flex: 688;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (${getMedias('TABLET')}) {
        background: none;
    }
`

export const TitleDescWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: fit-content;

    @media (${getMedias('TABLET')}) {
        display: none;
    }
`

export const ContentWrapper = styled.div`
    flex: 752;
    background: ${getColor('secondary', '700')};
    display: flex;
    align-items: center;
    padding-block: 80px;

    @media (${getMedias('TABLET')}) {
        width: 100%;
        position: absolute;
        top: 0;
        min-height: 100%;
        padding-bottom: 66px;
        padding-top: 120px;
        max-height: fit-content;
        display: flex;
        background: linear-gradient(#0575E6, #021B79);
        justify-content: center;
        align-items: flex-start;
    }
`

export const FormWrapper = styled.div`
    background: ${getColor('natural', '900')};
    border-radius: 30px;
    width: calc(100% + 42px);
    min-height: clamp(400px, 75vh, 761px);
    margin-left: clamp(-130px, -9vw, -40px);
    padding: clamp(20px, 4vw, 36px) ${getSectionPaddingsInline('md')};

    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 5%);

    @media (${getMedias('TABLET')}) {
        padding-block: 40px;
        margin-left: 0;
        border-radius: 20px;
        width: calc(100vw - clamp(10px, 13vw, 100px));
        min-height: 544px;
    }
`
